module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26.468\" height=\"26.468\" viewBox=\"0 0 26.468 26.468\">\n  <g transform=\"translate(0 0)\">\n    <line x2=\"26.468\" transform=\"translate(0 13.234)\" fill=\"#fff\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\"\n          stroke-width=\"4\"/>\n    <line y2=\"26.468\" transform=\"translate(13.234 0)\" fill=\"#fff\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\"\n          stroke-width=\"4\"/>\n  </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./app/assets/images/icons/btn_plus.svg
// module id = 49
// module chunks = 1